import * as Yup from "yup";

import ISubject, { ISubjectInput } from "@/interfaces/subject.interface";
import { SubjectFormMessages } from "@/messages/subject/subject-form.messages";

import { SubjectFormData } from "./types";

export const subjectFormNames: Record<keyof SubjectFormData, string> = {
  subject: "subject",
};

export const buildFormInitialData = (subject?: ISubject | null): SubjectFormData => {
  return {
    subject: subject?.subject || "",
  };
};

export const buildSubjectFormSchema = (messages: SubjectFormMessages) =>
  Yup.object().shape({
    subject: Yup.string().trim().required(messages.errorRequiredSubject).max(50),
  });

export const normalizeSubjectFormData = (formData: SubjectFormData): ISubjectInput => {
  return {
    subject: formData.subject.trim(),
  };
};
